import React from "react";
import { Spinner } from "react-bootstrap";
import './loader.css'
const Loader = () => {
  return (
    <div className="loader-main">
      <Spinner animation="border"  />
    </div>
  );
};

export default Loader;
